import React, {useState}from 'react' 

export function CameraIntro({ close, next ,dispatch, state}: { close: Function, next: Function,dispatch:Function, state: any }) {

  const [checked, setChecked]= useState(false)
  const [uncheckedMessage, setUncheckedMessage]=useState("")
  const selectors = {
    overlay: '[data-overlay]',
  }

  const overlay = document.querySelector(selectors.overlay);

  const nextStep = () => {
    overlay.classList.remove('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
    next();
  }

  const hideOverlay = () => {
    overlay.classList.remove('bg-black/[0.25]', 'fixed', 'inset-0', 'z-20');
    close();
  }

  const showOverlay = () => {
    overlay.addEventListener('click', hideOverlay);
  }

  const handleSkip=()=>{

    dispatch({
      type: "activeStep",
      value: state.activeStep+3
    })

  
    document.getElementById('closeCameroIntro').dispatchEvent(new Event('click')); 
  }

  showOverlay();

  return <div className="pt-4 pb-4 lg:py-24 flex flex-col lg:flex-row lg:gap-[16px] lg:items-center justify-start h-screen m-auto relative overflow-auto">
    <div className="flex justify-between items-center flex-col px-4 lg:p-5 lg:absolute lg:top-0 lg:right-0">
      <img id="closeCameroIntro" data-src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/icon-close.svg?v=1647350536" className="lazyload cursor-pointer self-end" onClick={() => hideOverlay()} />
      <h2 className="text-h3-m leading-none text-center mt-1 lg:hidden">Measure your cap size and lace tint with AI technology</h2>
    </div>

    <div className="lg:flex-[1_1_50%] mt-2.5 lg:mt-0 lg:h-full">
      <img className="lazyload w-full lg:h-full lg:object-cover" data-src="https://cdn.shopify.com/s/files/1/0562/6442/5517/files/sizing-guide.jpg" />
    </div>

    <div className="lg:flex-[1_1_50%] px-4 lg:pr-[44px] lg:pl-0">
      <h2 className="hidden lg:block lg:text-[40px] mt-1 lg:max-w-[564px]">Measure your cap size and lace tint with AI technology</h2>

      <hr className="hidden lg:block bg-black h-[10px] w-[246px] mt-4" />

      <p className="text-sm lg:text-xl text-center lg:text-left mt-3 lg:mt-6 lg:max-w-[564px]">Place a credit card (or the parfait calibration card) in front of your forehead, follow the camera guide, and take a photo. We recommend tying your hair back when taking these photos.
        <br />We recommend tying your hair back when taking these photos.</p>
        <p className="text-sm text-red-500 font-bold mt-[0.75rem]">{uncheckedMessage}</p>
        <div className="flex items-center mt-5">
   
        <input  onClick={() =>{
                            setChecked(!checked)
                            } } id="link-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
       <label  className="ml-2 text-sm font-bold text-gray-900 dark:text-gray-300 tooltip-popup">&nbsp; By using our application, you agree to our <a className='underline underline-offset-4 tooltip-link' href="https://myparfait.com/policies/privacy-policy">privacy policy</a> & <a  className='underline underline-offset-4 tooltip-link' href="https://myparfait.com/policies/terms-of-service">terms and conditions</a>.</label>
        </div>
        <div className="tooltip" id="tooltip"></div>
      <div className="block lg:inline-block">
        <button className="uppercase bg-black text-white block text-center text-btn-m lg:text-btn-d p-4 mt-6 w-full lg:w-[400px] mb-10" onClick={() =>{
          if(checked===false){
            setUncheckedMessage("Please check the checkbox!")
           }
          else{nextStep()}}}>Start camera</button>

        <button  onClick={handleSkip} className="text-sm underline underline-offset-4 font-medium mt-[0.75rem]">Having trouble taking photos? Click here to skip photos, you can always take them later</button>
      </div>
    </div>
  </div>
}
